import i, { forwardRef as d, useRef as a, useImperativeHandle as p, useEffect as f } from "react";
function b(o) {
  if (document.querySelector(`script[src="${o}"]`))
    return;
  const e = document.createElement("script");
  e.src = o, e.async = !0, e.type = "module", document.head.appendChild(e);
}
function h(o, e) {
  for (const [n, t] of Object.entries(e))
    t != null && o.setAttribute(n, t.toString());
}
function N(o = {}, e = null) {
  customElements.whenDefined("hyvor-talk-comment-count").then(() => {
    window.hyvorTalkCommentCounts.load(o, e);
  });
}
const E = [
  "loaded",
  "comment:published",
  "comment:edited",
  "comment:deleted",
  "comment:voted",
  "comment:flagged",
  "reaction",
  "rating",
  "auth:login:clicked",
  "profile:clicked"
];
class y {
  static script(e) {
    e = e || "https://talk.hyvor.com", b(`${e}/embed/embed.js`);
  }
  static comments(e, n, t) {
    y.script(e.instance);
    const r = document.createElement("hyvor-talk-comments");
    for (let [s, c] of Object.entries(e))
      if (c != null) {
        if (s === "translations" && typeof c == "object") {
          for (let [l, m] of Object.entries(c))
            l = l.replace("_", "-"), r.setAttribute(`t-${l}`, m);
          continue;
        }
        s === "settings" && (c = JSON.stringify(c)), r.setAttribute(s, c);
      }
    return t && E.forEach((s) => {
      r.addEventListener(s, (c) => {
        t(s, c.detail);
      });
    }), n.appendChild(r), r;
  }
}
const k = "https://talk.hyvor.com";
class w {
  static script(e) {
    e = e || k, b(`${e}/embed/comment-counts.js`);
  }
  static commentCount(e, n) {
    w.script(e.instance);
    const t = document.createElement("hyvor-talk-comment-count");
    return h(t, e), n.appendChild(t), t;
  }
  static load(e = {}, n = null) {
    w.script(), customElements.whenDefined("hyvor-talk-comment-count").then(() => {
      window.hyvorTalkCommentCounts.load(e, n);
    });
  }
}
class C {
  static script(e) {
    e = e || k, b(`${e}/embed/newsletter.js`);
  }
  static form(e, n) {
    C.script(e.instance);
    const t = document.createElement("hyvor-talk-newsletter");
    return h(t, e), n.appendChild(t), t;
  }
}
const g = [
  "loaded",
  "subscription:created",
  "subscription:success",
  "subscription:updated"
];
class v {
  static script(e) {
    e = e || k, b(`${e}/embed/memberships.js`);
  }
  static memberships(e, n, t) {
    v.script(e.instance);
    const r = document.createElement("hyvor-talk-memberships");
    return h(r, e), t && g.forEach((s) => {
      r.addEventListener(s, (c) => {
        t(s, c.detail);
      });
    }), n = n || document.body, n.appendChild(r), r;
  }
  static gatedContent(e, n) {
    const t = document.createElement("hyvor-talk-gated-content");
    return h(t, e), n.appendChild(t), t;
  }
}
const $ = d((o, e) => {
  const n = a(null), t = a(null), { on: r, ...s } = o;
  return p(e, () => ({
    wrap: () => n.current,
    element: () => t.current
  }), []), f(() => (t.current = y.comments(
    s,
    n.current,
    (c, l) => {
      var u;
      const m = (u = o.on) == null ? void 0 : u[c];
      m && typeof m == "function" && m(l);
    }
  ), () => {
    var c;
    (c = t.current) == null || c.remove();
  }), []), /* @__PURE__ */ i.createElement("div", { className: "ht-comments-wrap", ref: n });
}), O = d((o, e) => {
  const n = a(null), t = a(null);
  return p(e, () => ({
    wrap: () => n.current,
    element: () => t.current
  }), []), f(() => (t.current = w.commentCount(o, n.current), () => {
    var r;
    (r = t.current) == null || r.remove();
  }), []), /* @__PURE__ */ i.createElement("span", { className: "ht-comment-count-wrap", ref: n });
}), A = d((o, e) => {
  const n = a(null), t = a(null);
  return p(e, () => ({
    wrap: () => n.current,
    element: () => t.current
  }), []), f(() => (t.current = C.form(
    o,
    n.current
  ), () => {
    var r;
    (r = t.current) == null || r.remove();
  }), []), /* @__PURE__ */ i.createElement("div", { className: "ht-newsletter-wrap", ref: n });
}), R = d((o, e) => {
  const n = a(null), t = a(null), { on: r, ...s } = o;
  return p(e, () => ({
    wrap: () => n.current,
    element: () => t.current
  }), []), f(() => (t.current = v.memberships(
    s,
    n.current,
    (c, l) => {
      var u;
      const m = (u = o.on) == null ? void 0 : u[c];
      m && typeof m == "function" && m(l);
    }
  ), () => {
    var c;
    (c = t.current) == null || c.remove();
  }), []), /* @__PURE__ */ i.createElement("div", { className: "ht-memberships-wrap", ref: n });
}), S = d((o, e) => {
  const n = a(null), t = a(null);
  return p(e, () => ({
    wrap: () => n.current,
    element: () => t.current
  }), []), f(() => {
    const r = { ...o };
    return r._key && (r.key = r._key, delete r._key), t.current = v.gatedContent(
      r,
      n.current
    ), () => {
      var s;
      (s = t.current) == null || s.remove();
    };
  }, []), /* @__PURE__ */ i.createElement("div", { className: "ht-gated-content-wrap", ref: n });
});
export {
  O as CommentCount,
  $ as Comments,
  S as GatedContent,
  R as Memberships,
  A as NewsletterForm,
  N as loadCommentCounts
};
